const elements = {
  gold: document.getElementById('gold-display'),
  essence: document.getElementById('essence-display'),
  round: document.getElementById('round-display'),
  era: document.getElementById('era-display'),
  waveStatus: document.getElementById('wave-status'),
  waveInfo: document.getElementById('wave-info'),
  waveInfoContent: document.getElementById('wave-info-content'),
  waveSkipButton: document.getElementById('btn-wave-skip'),
  selectionInfo: document.getElementById('selection-info'),
  unitPanel: document.querySelector('.unit-panel'),
  musicWidget: document.getElementById('music-widget'),
  youtubePlayerSlot: document.getElementById('yt-player'),
  youtubeTitle: document.getElementById('yt-title'),
  youtubeBtnPlay: document.getElementById('yt-btn-play'),
  youtubeBtnNext: document.getElementById('yt-btn-next'),
  commandGrid: document.getElementById('command-grid'),
  commandPanelTitle: document.querySelector('.command-panel .panel-title'),
  battlefield: document.querySelector('.battlefield'),
  gameCanvas: document.getElementById('game-canvas'),
  commandSlots: Array.from(document.querySelectorAll('.command-slot')),
  bossCountdown: document.getElementById('boss-countdown-display'),
  cameraOverlay: document.getElementById('camera-overlay'),
  lobbyOverlay: document.getElementById('scene-lobby'),
  settingsOverlay: document.getElementById('scene-settings'),
  difficultyOverlay: document.getElementById('scene-difficulty'),
  playButton: document.getElementById('btn-play'),
  settingsButton: document.getElementById('btn-settings'),
  exitButton: document.getElementById('btn-exit'),
  settingsBackButton: document.getElementById('btn-settings-back'),
  settingsToLobbyButton: document.getElementById('btn-settings-to-lobby'),
  difficultyBackButton: document.getElementById('btn-difficulty-back'),
  settingsTabs: Array.from(document.querySelectorAll('.settings-tab')),
  settingsSections: Array.from(document.querySelectorAll('.settings-section')),
  settingAutoFullscreen: document.getElementById('setting-auto-fullscreen'),
  settingSensitivity: document.getElementById('setting-sensitivity'),
  settingSensitivityValue: document.getElementById('setting-sensitivity-value'),
  settingPanSpeed: document.getElementById('setting-pan-speed'),
  settingPanSpeedValue: document.getElementById('setting-pan-speed-value'),
  settingBgmVolume: document.getElementById('setting-bgm-volume'),
  settingBgmVolumeValue: document.getElementById('setting-bgm-volume-value'),
  settingSfxVolume: document.getElementById('setting-sfx-volume'),
  settingSfxVolumeValue: document.getElementById('setting-sfx-volume-value'),
  dockyardUsage: document.getElementById('dockyard-usage'),
  gameOverOverlay: document.getElementById('scene-gameover'),
  gameOverTitle: document.getElementById('gameover-title'),
  gameOverMessage: document.getElementById('gameover-message'),
  gameOverStats: document.getElementById('gameover-stats'),
  gameOverContinue: document.getElementById('btn-gameover-continue'),
  gameOverRetry: document.getElementById('btn-gameover-retry'),
  gameOverLobby: document.getElementById('btn-gameover-lobby'),
  difficultyButtons: Array.from(document.querySelectorAll('[data-difficulty]')),
  difficultyLabel: document.getElementById('difficulty-label'),
  difficultySummary: document.getElementById('difficulty-summary'),
};

export { elements };
